export default __webpack_public_path__ + "static/media/weight-loss_person-on-scales.54f2a86c.jpg";